var SWAN_PUBLIC_ASSET_FOLDER = 'v2-assets';
var SWAN_VERSION = '2.7.2';
var SWAN_HASHED_FOLDER = 'v2';
var SWAN_VERSIONED_FOLDER = 'v2.7.2';
export { SWAN_HASHED_FOLDER, SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSION, SWAN_VERSIONED_FOLDER };